import {
  AutocompleteInput,
  type AutocompleteInputProps,
} from "@repo/ui/components/Base/AutocompleteInput";
import { useFormikContext } from "formik";

export interface FormikAutocompleteProps extends AutocompleteInputProps {
  name: string;
}

export const FormikAutocomplete = ({ ...props }: FormikAutocompleteProps) => {
  const { setFieldValue } = useFormikContext();

  return (
    <AutocompleteInput
      onChange={(value) => setFieldValue(props.name, value)}
      filterOptions={false}
      {...props}
    />
  );
};
